import {session} from "@/utils/session"

export default {
    namespaced: true,
    state: {
        token: session.getValue('token'),
        note: session.getValue('nota')
    },

    mutations: {
        SET_NOTE_AUTH(state) {
            state.token = session.getValue('token')
            state.note = session.getValue('nota')
        }
    },

    actions: {

        loginAuth: async ({commit, rootState}, data) => {
            await rootState.init.http_common.get('/notas/'+data.numdoc,{
                headers: {
                    'X-facturadortoken': data.numdoc +"-"+data.codfact
                }
            }).then((response) => {
                session.set({token: data.numdoc +"-"+ data.codfact, nota:response.data.result });
                commit('SET_NOTE_AUTH');
            })
        },


        clearAuth({commit}) {
            session.remove();
            commit('SET_NOTE_AUTH');

        }

    }

}
